<template>
  <div>
    <v-app-bar app tile height="30" class="glass" :dark="dark">
      <v-btn
        id="expMenu"
        tile
        icon
        small
        class="mr-2"
        @click.stop="mini = !mini"
      >
        <v-icon :color="iconColor">{{
          mini ? "mdi-menu-close" : "mdi-menu-open"
        }}</v-icon>
      </v-btn>
      <v-tooltip activator="#expMenu" bottom>
        {{ mini ? "Expandir Menú" : "Contraer Menú" }}
      </v-tooltip>
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click.stop="switchDrawer(true)"
      ></v-app-bar-nav-icon>

      <v-toolbar-title
        v-if="loading || (!loading && validIndicadores)"
        class="cabecera"
      >
        <v-chip small :color="chipColor" class="mr-2">
          <v-icon small left>mdi-chart-bar</v-icon>

          <v-skeleton-loader
            v-if="loading"
            class="text-skeleton"
            type="text"
            dark
            width="50px"
          ></v-skeleton-loader>
          <span v-else>UF: ${{ conv.formatMontoDec(indicadores.uf) }}</span>
        </v-chip>
        <v-chip small :color="chipColor">
          <v-icon small left>mdi-chart-bar</v-icon>
          <v-skeleton-loader
            v-if="loading"
            class="text-skeleton"
            type="text"
            dark
            width="50px"
          ></v-skeleton-loader>
          <span v-else>US: ${{ conv.formatMontoDec(indicadores.dolar) }}</span>
        </v-chip>
      </v-toolbar-title>
      <div v-if="blockAccess" class="maes">UTILIZANDO CLAVE MAESTRA</div>
      <v-spacer></v-spacer>
      <v-btn
        v-if="paramGenerales.mostrar_precios"
        :disabled="ticket_qa"
        small
        text
        class="font-weight-regular"
        :to="{ name: 'precios' }"
      >
        <v-icon :color="iconColor" left> mdi-invoice-text-arrow-right </v-icon>
        Precios
      </v-btn>

      <v-menu bottom left offset-y v-if="paramGenerales.mostrar_ayudas">
        <template v-slot:activator="{ on, attrs }">
          <v-badge
            :value="ayudaList.some((item) => item.nuevo)"
            dot
            color="error"
            overlap
            offset-x="10"
            offset-y="10"
          >
            <v-btn
              id="menuAyuda"
              v-bind="attrs"
              v-on="on"
              small
              text
              class="font-weight-regular"
            >
              <v-icon :color="iconColor" left> mdi-help-circle </v-icon>
              Ayuda
            </v-btn>
          </v-badge>
        </template>

        <v-list dense class="pa-0">
          <div v-for="(item, i) in ayudaList" :key="i">
            <v-list-item link @click="openAyuda(item)">
              <v-icon :color="item.type === 'video' ? 'primary' : 'error'" left>
                {{ item.type === "video" ? "mdi-video" : "mdi-file-pdf-box" }}
              </v-icon>
              <v-list-item-title>
                {{ item.title }}
                <v-chip v-if="item.nuevo" pill x-small color="primary">
                  <v-icon x-small left>mdi-star</v-icon>
                  Nuevo
                </v-chip>
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
          </div>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-dialog
      v-model="dialog"
      v-if="dialog"
      width="auto"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-toolbar color="primary" dark flat tile dense>
          <v-toolbar-title class="flex text-center titulo titulo-local">{{
            selectedItem.title
          }}</v-toolbar-title>
          <v-btn icon dark @click="closeAyuda()">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <div v-if="selectedItem.type === 'video'" class="py-1 text-center">
            <strong>
              Asegúrese de seleccionar calidad 720p o superior para una mejor
              experiencia de visualización
            </strong>
          </div>
          <iframe
            v-if="selectedItem.type === 'video'"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            width="760"
            height="428"
            :src="ftp + selectedItem.nombre"
            frameborder="0"
            allowfullscreen
          ></iframe>
          <iframe
            v-else
            :src="`${publicPath}${selectedItem.nombre}`"
            style="height: 90vh"
            width="1000px"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-tooltip
      v-if="tooltip"
      v-model="tooltip"
      color="primary"
      :timeout="15000"
      activator="#menuAyuda"
      max-width="225"
      bottom
      content-class="click-pointer"
    >
      <div class="d-flex justify-space-around">
        <span class="top-right-tooltip">
          Si tiene dudas revise nuestro Manual de Usuario para el uso del
          sistema
        </span>
        <v-btn x-small icon class="ml-1" @click="tooltip = false">
          <v-icon color="white">mdi-close-circle</v-icon>
        </v-btn>
      </div>
    </v-tooltip> -->
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import { videos } from "./data/videos";
import config from "@/config/configBase";
import conv from "@/services/conversores";

export default {
  data() {
    return {
      conv,
      ayudaList: [],
      dialog: false,
      ftp: "https://drive.google.com/file/d/",
      publicPath: process.env.BASE_URL,
      loading: true,
      dark: config.dark,
      chipColor: config.chipColor,
      iconColor: config.btnColor,
    };
  },
  computed: {
    ...mapState([
      "paramGenerales",
      "indicadores",
      "contadorTickets",
      "blockAccess",
    ]),
    ...mapGetters(["getMini", "getParams"]),
    mini: {
      get() {
        return this.getMini;
      },
      set(newVal) {
        this.SET_MINI(newVal);
        return newVal;
      },
    },

    validIndicadores() {
      return this.indicadores.uf > 1 && this.indicadores.dolar > 1;
    },
    ticket_qa() {
      return (
        this.contadorTickets.ticket_qa > 0 && this.getParams["3134"]?.valor == 1
      );
    },
  },
  async mounted() {
    await this.obtenerIndicadores();
    this.loading = false;
  },
  created() {
    this.setAyudaList();
  },
  methods: {
    ...mapMutations(["SET_MINI"]),
    ...mapActions(["switchDrawer", "obtenerIndicadores"]),
    setAyudaList() {
      this.ayudaList = videos.map((item) => {
        if (item.nuevo) item.nuevo = localStorage.getItem(item.nombre) != "1";
        return item;
      });
    },
    openAyuda(item) {
      this.dialog = true;
      this.selectedItem = item;
      localStorage.setItem(item.nombre, "1");
    },
    closeAyuda() {
      this.setAyudaList();
      this.dialog = false;
      this.selectedItem = null;
    },
  },
};
</script>

<style scoped lang="css">
.click-pointer {
  pointer-events: auto !important;
  padding: 5px !important;
  padding-left: 12px !important;
}

.cabecera {
  font-weight: 400;
}
.maes {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 26px;
}
</style>
